import React from "react";
import { useOutletContext } from "react-router-dom";
// components
import RMDRImage from "@/components/RMDRImage";
import RMDRLink from "@/components/RMDRLink";
import NoData from "@/components/NoData";
import { HiOutlineNewspaper } from "react-icons/hi2";
// types
import { TMainPageLayoutV3 } from "../type";
import TOutletContext from "@/cms/types/TOutletContext";
import TClientContentList from "@/cms/types/TClientContentList";
import TClientMainPageItemList from "@/cms/types/TClientMainPageItemList";
// utilities
import { 
    metaDataLanguageVersion, 
    pageNameDescriptionLanguageVersion, 
    redirectUrl 
} from "@/utilities/LanguageVersionSelectorShortcut";
// enums
import EResourceType from "@/cms/enums/EResourceType";
import RMDRComponentSanitizer from "@/components/RMDRComponentSanitizer";


type TMNPG016 = {
    params:{
        payloadList?:TClientContentList[];
        payloadListIsLoading?:boolean;
        payloadListCount?:number;
        [key:string]:any;
    }
}

type TRenderItems = {
    payloadList?:TClientContentList[];
    template?:TClientMainPageItemList;
    careProgramVarString01:string;
    careProgramVarString02:string;
    careProgramVarString03:string;
}

const RenderItems = ( props:TRenderItems ) => {
    return props.payloadList?.map((item, index) => {
        const itemLanguageVersion = pageNameDescriptionLanguageVersion(item?.languageVersions);
        const _redirectUrl = redirectUrl(item.languageVersions);
        
        const careProgramVar01 = metaDataLanguageVersion("careProgramVar01", item.languageVersions);
        const careProgramVar02 = metaDataLanguageVersion("careProgramVar02", item.languageVersions);
        const careProgramVar03 = metaDataLanguageVersion("careProgramVar03", item.languageVersions);

        return (
            <div
                className="col-xl-4 col-lg-6 col-md-6 "
                data-aos-duration="800"
                data-aos="fade-up"
                data-aos-delay="300"
            >
                <div className="clases-items mt-0">
                    <div className="clases-bg style-2"></div>
                    <div className="clases-image">
                        <RMDRImage
                            resourceType={EResourceType.OUTER_IMAGE} 
                            resources={item.resources}
                            alt={itemLanguageVersion?.name} 
                            title={itemLanguageVersion?.name}
                        />
                    </div>
                    <div className="clases-content">
                        <h4>
                            <RMDRLink
                                text={itemLanguageVersion?.name}
                                title={itemLanguageVersion?.name}
                                hasNavigationDestination={props.template?.hasDestinationNavigation}
                                navigationURL={itemLanguageVersion?.contentRouteNavigationURL}
                                redirectType={props.template?.redirectType}
                                isShowAlways
                                variant="span"
                            />
                        </h4>
                        <p>
                            <RMDRComponentSanitizer 
                                languageVersion={itemLanguageVersion}
                                variant="span"
                                valueExpr="value"
                                className="tw-line-clamp-6"
                                removeTag
                            />
                        </p>
                        {/* <ul className="clases-schedule">
                            <li>
                                <span>{props.careProgramVarString01}</span><br />{careProgramVar01}
                            </li>
                            <li>
                                <span>{props.careProgramVarString02}</span><br />{careProgramVar02}
                            </li>
                            <li>
                                <span>{props.careProgramVarString03}</span><br />{careProgramVar03}
                            </li>
                        </ul> */}
                    </div>
                </div>
            </div>
        )
    })
}

const LoadingSkeleton = () => {
    return (
        <>
            {
                Array.from({ length:6 }).map(() => (
                    <div className="col-xl-4 col-lg-6 col-md-6 tw-animate-pulse">
                        <div className="tw-h-96 tw-bg-gray-100" />
                    </div>
                ))
            }
        </>
    )
}

const MNPG016 = ( props: TMainPageLayoutV3<TMNPG016> ) => {
    console.log("MNPG016.rendered: ", props);

    const { siteSettingPayload } = useOutletContext<TOutletContext>();
    const { params } = props;
    const { payloadList, payloadListIsLoading=true, payloadListCount=0 } = params;

    const careProgramVarString01 = metaDataLanguageVersion("careProgramVarString01", siteSettingPayload.languageVersions);
    const careProgramVarString02 = metaDataLanguageVersion("careProgramVarString02", siteSettingPayload.languageVersions);
    const careProgramVarString03 = metaDataLanguageVersion("careProgramVarString03", siteSettingPayload.languageVersions);

    return (
        <div className="row g-4">
            {
                payloadListIsLoading && <LoadingSkeleton />
            }
            {
                !payloadListIsLoading && payloadList && payloadList?.length > 0 && payloadListCount > 0 && (
                    <RenderItems
                        payloadList={payloadList}
                        template={props.template}
                        careProgramVarString01={careProgramVarString01}
                        careProgramVarString02={careProgramVarString02}
                        careProgramVarString03={careProgramVarString03}
                    />
                )
            }
            {
                !payloadListIsLoading && payloadList?.length === 0 && payloadListCount === 0 && (
                    <NoData
                        icon={<HiOutlineNewspaper className="tw-h-40 tw-stroke-1 tw-text-9xl" />}
                        className="tw-flex tw-flex-col tw-items-center tw-justify-center"
                        textClassName="tw-text-center tw-text-xl"
                        languageVersions={siteSettingPayload.languageVersions}
                    />
                )
            }
        </div>
        
    )
}

const Component = React.memo(MNPG016, ( prevProps:TMainPageLayoutV3<TMNPG016>, nextProps:TMainPageLayoutV3<TMNPG016> ) => {
    return !(
        prevProps.params?.payloadList !== nextProps.params?.payloadList
        || prevProps.params?.payloadListIsLoading !== nextProps.params?.payloadListIsLoading
        || prevProps.params?.payloadListCount !== nextProps.params?.payloadListCount
    );
});

export default Component;
